<!-- ======= Contact Section ======= -->
<section id="contact" class="contact section-bg" style="margin-top:90px;">
    <div id="contactcontiner" class="container" data-aos="fade-up">

        <div class="section-title">
            <h3>Please enter all the details to register for the meeting</h3>
        </div>

        <div class="row mt-1 d-flex justify-content-end" data-aos="fade-right" data-aos-delay="100">

            <div class="col-lg-12 mt-lg-0" data-aos="fade-left" data-aos-delay="100">
                <div class="row">
                    <div class="col-md-4 mt-2">
                        <input type="text" name="name" [(ngModel)]="name" class="form-control redborder" id="name"
                            placeholder="Your Name" minlength="4" />
                    </div>
                    <div class="col-md-4 mt-2">
                        <input type="text" name="company" [(ngModel)]="company" class="form-control redborder"
                            id="company" placeholder="Your Company/Organization" minlength="4" />
                    </div>
                    <div class="col-md-4 mt-2">
                        <input type="text" name="email" [(ngModel)]="email" class="form-control" id="email"
                            placeholder="Your Email Address" minlength="4" />
                    </div>
                </div>

                <div class="row mt-2"></div>

                <div class="row">
                    <!-- <div class="col-md-6 mt-2 input-group mb-3"> -->
                        <!-- <div class="row">
                            <div [innerHtml]='msg' *ngIf="msg" style="color: red;"></div>
                        </div> -->
                        <!-- <div class="row mt-4" *ngIf="eventDetails">
                            <div class="col-md-2"></div>
                            <div class="col-md-8">
                                <div class="widget-user-image">
                                   
                                    <img [src]="url?.base64" alt="" class="img-fluid">
                                </div>

                            </div>
                            <div class="col-md-2"></div>
                        </div> -->
                        <!-- <div class="row mt-2" *ngIf="eventDetails">
                            <div class="col-md-12">
                                <div class="custom-file">
                                    <input type="file" class="custom-file-input" id="inputGroupFile01"
                                        (change)="fileChangeHandler($event)">
                                        
                                    <label class="custom-file-label" for="inputGroupFile01">Take a Selfie</label>
                                </div>
                            </div>
                        </div> -->

                    <!-- </div> -->
                    <div class="col-md-6">
                        <div class="selfie row mt-2" *ngIf="eventDetails">
                            <div>
                                 <button type="button" class="btn btn-primary" (click)="Takeselfie()"><i class="bi bi-camera"></i> Take selfie</button>
                            </div>
                        </div>
                        <!-- <p-progressBar class="p-2" mode="indeterminate" *ngIf="isImageLoad" [style]="{ height: '6px' }"></p-progressBar> -->
                        <!-- <div *ngIf="isImageLoad">Please wait</div> -->
                        <webcam [height]="300"
                                [width]="300"
                                class="abc"
                                mirrorImage="never"
                                [trigger]="triggerObservable"
                                (imageCapture)="handleImage($event)"
                                [allowCameraSwitch]="allowCameraSwitch"
                                [switchCamera]="nextWebcamObservable"
                                [videoOptions]="videoOptions"
                                (cameraSwitched)="cameraWasSwitched($event)"
                                (initError)="handleInitError($event)"
                                
                                *ngIf="OpenWebCam"></webcam>
                                <div class=" row justify-content-space-between align-item-center" *ngIf="OpenWebCam==true && !isImageLoad">
                                   <div class="action_button"><a (click)="removeCaptureImage()"><i class="fa fa-trash-o" style="font-size:18px;color:red"></i>Clear</a></div>
                                   <div class="action_button"><a (click)="triggerSnapshot()"><i class="fa fa-camera" style="font-size:18px"></i>Capture</a> </div>
                               </div>
                                   <br />
                
                                   <div class="col-md-12" *ngIf="!isImageLoad">
                                     <div class="" *ngIf="userimage!==undefined && userimage!=''">
                                       <a (click)="removeRosterImage()"><i class="fa fa-trash-o" style="font-size:18px;color:red"></i>Clear</a>
                                     </div><br />
                                     <img [src]="userimage" *ngIf="userimage!==undefined && userimage!=''" class="responsiveImg" />
                                     <div class="" *ngIf="IsImageUploadForCrop==true && imageBase64String!==undefined && imageBase64String!=''">
                                       <a (click)="CropImageCLose()"> <i class="fa fa-trash-o" style="font-size:18px;color:red"></i>Clear</a> &nbsp;&nbsp;
                                       <a (click)="CropImage()"><i class="bi bi-check-circle"></i>Done</a>
                                     </div><br />
                
                
                                   </div>
                               </div>

                    <div class="col-md-3 mt-2">
                        <button type="button" class="btn btn-outline-primary btn-lg btn-block"
                            (click)="showsignaturepopup()">Add Signature</button>
                        <img [src]="sign" *ngIf="sign">
                    </div>

                    <div class="col-md-3 mt-2">
                        <button type="button" class="btn btn-outline-primary btn-lg btn-block"
                            (click)="clearSignature()">Clear Signature</button>                        
                    </div>

                </div>

                <div class="row">
                    <div class="col-md-3 mt-3">
                        <button type="button" class="btn btn-outline-primary btn-lg btn-block"
                            (click)="showpopup()">Enter Meeting</button>
                    </div>
                    <div class="col-md-3 mt-3">
                        <button type="button" class="btn btn-outline-primary btn-lg btn-block"
                            (click)="backToLiveEvents()">Back to Live Events</button>
                        <!-- (click)="sendmessage()" -->
                    </div>
                    <!-- <div class="col-md-3">
                        
                        <ngx-photo-editor [imageChanedEvent]="imageChangedEvent" (imageCropped)="imageCropped($event)"
                            [aspectRatio]="4/3" [viewMode]="3" [resizeToWidth]="500"></ngx-photo-editor>
                    </div> -->
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" style="top: 10%;" aria-labelledby="exampleModalLabel"
        aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Confirm your details</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div>Is your name, company name, and e-mail address correct?</div>
                    <p></p>
                    <table class="table table-sm">
                        <tbody>
                            <tr>
                                <th scope="row">Name :</th>
                                <td>{{name}}</td>
                            </tr>
                            <tr>
                                <th scope="row">Company Name:</th>
                                <td>{{company}}</td>

                            </tr>
                            <tr *ngIf="email!==''">
                                <th scope="row">Email Address</th>
                                <td>{{email}}</td>

                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                    <button type="button" class="btn btn-primary" (click)="submitData()">Enter Meeting</button>
                </div>
            </div>
        </div>
    </div>



    <div class="modal fade" id="signatureModal" tabindex="-1" style="top: 10%;" role="dialog" aria-labelledby="exampleModalLabel"
        aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Confirm your details</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true" (click)="clearSignature()" >&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <button type="button" (click)="clearSignature()" class="btn btn-outline-primary btn-small">Clear
                        Signature X</button>
                    <div class="row">
                        <div class="col-md-12 mt-2" style="border: solid 1px black;">
                            <signature-pad #signatureCanvas [options]="signaturePadOptions" (onBeginEvent)="drawStart()"
                                (onEndEvent)="drawComplete()"></signature-pad>
                        </div>

                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" (click)="createSign()" data-dismiss="modal">Save</button>
                </div>
            </div>
        </div>
    </div>
</section><!-- End Contact Section -->